import classNames from 'classnames';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { getDimensions } from '../../core/dimensions';
import { letterSizes } from '../../core/price';
import Lines from './Lines';
import Overlay from './Overlay';

interface iViewerProps {
  value: any;
  support: string;
  background: string;
  onError?: (error: string | null) => void;
  weight: string;
  lineHeight: number;
  alignment: string;
  dimensions?: number[];
  size: string;

  containerRef: any;
}

export const useDimensions = (size: string, value: any, lineHeight: number) => {
  // const config = useConfig();
  // const activeSize = config.options.sizes.find((_) => _.value === size);
  const letterWidth = parseFloat(size?.split('_')?.[1]?.split('x')[0] ?? 0) || letterSizes[size];
  // const dims = activeSize?.dimensions ??
  //   size
  //     .split('_')?.[1]
  //     ?.split('x')
  //     ?.map((_) => parseInt(_)) ?? [0, 0];
  // const letterHeight = dims[1];
  // const width = useMemo(() => {
  //   const lineWidths = value.map((line: any) => {
  //     const lineContent = line.children.map((leaf: any) => leaf.text).join('');
  //     // .replace(/ /g, '');

  //     return lineContent.length * letterWidth;
  //   });

  //   return Math.max(...lineWidths);
  // }, [JSON.stringify(value), letterWidth]);

  // const lineHeightDimensions = 10 + lineHeight;

  // const height = useMemo(() => {
  //   const lineNum = value.filter((_: any) => _.children.filter((_: any) => !!_.text).length > 0).length;
  //   return lineNum * letterHeight + Math.max(0, lineHeightDimensions * (lineNum - 1));
  // }, [
  //   JSON.stringify(value),
  //   JSON.stringify(config.options.families),
  //   JSON.stringify(sizes),
  //   letterHeight,
  //   lineHeightDimensions,
  //   letterWidth,
  // ]);

  const dimensions = useMemo(() => {
    return getDimensions(letterWidth, lineHeight, value);
  }, [letterWidth, value, lineHeight]);

  return dimensions; //{ width, height };
};

// TODO: how to calculate the distance between the lines
// TODO: fix overlay width calculation
const Viewer: FC<iViewerProps> = ({
  size,
  value,
  support,
  background: backgroundKey,
  weight,
  lineHeight,
  alignment,
  containerRef,
  onError,
}) => {
  // const config = useConfig();
  const wrapper = useRef<HTMLDivElement>(null);
  const [isDay, setIsDay] = useState(true);
  const [isOn, setIsOn] = useState(true);
  const [scale, setScale] = useState(0.5);

  // const activeSize = config.options.sizes.find((_) => _.value === size);
  const letterWidth = parseFloat(size?.split('_')?.[1]?.split('x')[0] ?? 0) || letterSizes[size];
  console.log(letterWidth, letterSizes, size);

  const { width, height } = useDimensions(size, value, lineHeight);

  const margin = lineHeight * 2;

  const _handleCalculateScale = () => {
    if (!wrapper.current) return;
    const { width: _width, height } = wrapper.current?.getBoundingClientRect();
    const wrapperSize = Math.max(height, _width);
    setScale(!width ? 1 : ((letterWidth / 80) * wrapperSize) / 150);
  };

  const _handleZoom = (change: number) => {
    const ratio = change > 0 ? 1.2 : 1 / 1.2;
    setScale(Math.max(0.5, Math.min(1.5, scale * ratio)));
  };

  useEffect(() => {
    _handleCalculateScale();
    window.addEventListener('resize', _handleCalculateScale);
    return () => window.removeEventListener('resize', _handleCalculateScale);
  }, [size, letterWidth]);

  useEffect(() => {
    onError?.(width > 200 ? 'Sign too big' : null);
  }, [width]);

  return (
    <div ref={wrapper} className={classNames('viewer-wrapper', isDay && 'day')}>
      <Overlay
        {...{
          dimensions: [0, 0],
          isOn,
          isDay,
          setIsDay,
          setZoom: _handleZoom,
          setIsOn,
          background: undefined,
          alignment,
          support,
          width,
          height,

          scale,
          widthError: false,
          heightError: false,

          containerRef,
        }}
      >
        <Lines {...{ value, margin, support, isOn, sizeModified: 1, weight, scale: 1 || scale }} />
      </Overlay>
    </div>
  );
};

export default Viewer;
